export default __webpack_public_path__ + "static/media/4.34d8e181.jpg";